module.exports = __webpack_public_path__ + "media/images/food_plchldr-dfb9552fe6b80632244096e7dee1dbc0.svg";